import React from 'react'
import { Student, TSModuleProfile, LLModuleProfile } from '../interfaces/ModuleTypes'

export type DataContextType = {
    allStudents: Student[]
    allProfiles: any[]
    simProfiles: TSModuleProfile[]
    labProfiles: LLModuleProfile[]
}

export const initialData: DataContextType = {
    allStudents: [],
    allProfiles: [],
    simProfiles: [],
    labProfiles: []
}

const dataContext = React.createContext<DataContextType>(initialData)

export const DataContext = dataContext
export const DataContextProvider = dataContext.Provider
export const DataContextConsumer = dataContext.Consumer